import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IAcademicGroupMember } from "./routeType";

const { key, getPath } = getApi("academicGroups.member.getAll");

type IExtractedRouteType =
  IAcademicGroupMember["academicGroupSingleMembersCollectionRetrieve"];

export type IGetAllAcademicGroupMembers =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllAcademicGroupMembers: Fetcher<
  IGetAllAcademicGroupMembers["response"],
  IGetAllAcademicGroupMembers["variables"]
> = ({ academicGroupId, ...params }) => {
  return axiosClient.get(getPath({ academicGroupId }), { params });
};

export const useGetAllAcademicGroupMembers = createQuery({
  queryKey: [key],
  fetcher: getAllAcademicGroupMembers,
});
